export default {"src":"/fly/_next/static/media/flight-tick.ef376dac.svg","height":28,"width":30,"blurWidth":0,"blurHeight":0};